export default {
  local: 'http://localhost:6006',
  development: 'https://apibetanotificacoes.tron.com.br',
  production: 'https://apinotificacoes.tron.com.br',
};
